<div class="backgroundPopOver">
  <ul class="no-bullet" *ngIf="valuesPossibles?.length">
    <li class="text" [ngClass]="{ highlight: isAnswer(item.code) }" *ngFor="let item of valuesPossibles">- {{ item.display }}</li>
  </ul>
  <p class="text" *ngIf="!valuesPossibles?.length && answerType !== INPUT_TYPE.EXTERNAL_LINK">{{ "popover.freeText" | translate }}</p>
</div>
